import { create } from 'zustand'

// ─────────────────────────────────────────────────────────────────────────
// Theme preference (dark / light). Persisted to localStorage so the
// chosen mode survives page reload. For now the only consumer is
// ListDealsPage (proof-of-concept); the same `data-theme` attribute
// pattern will propagate to other pages as we convert each one.
// ─────────────────────────────────────────────────────────────────────────

const STORAGE_KEY = 'truedesking:theme'

const readPersistedTheme = () => {
    try {
        const v = window.localStorage.getItem(STORAGE_KEY)
        return v === 'light' || v === 'dark' ? v : 'dark'
    } catch (_e) {
        return 'dark'
    }
}

const persistTheme = (theme) => {
    try {
        window.localStorage.setItem(STORAGE_KEY, theme)
    } catch (_e) { /* private mode / disabled storage — ignore */ }
}

export const useThemeStore = create((set, get) => ({
    theme: readPersistedTheme(),

    setTheme: (theme) => {
        if (theme !== 'light' && theme !== 'dark') return
        persistTheme(theme)
        set({ theme })
    },

    toggleTheme: () => {
        const next = get().theme === 'dark' ? 'light' : 'dark'
        persistTheme(next)
        set({ theme: next })
    },
}))
